import React from "react";

const Navbar = () => {
    return (
        <div className="nav-left">
            <div className="nav-left-item">
                <a
                    href="CV_Mile_Ristov_Frontend_Developer.pdf"
                    target="_blank"
                    rel="noreferrer"
                    className="nav-left-link"
                >
                    CV
                </a>
            </div>
            <div className="nav-left-item">
                <a
                    href="https://www.linkedin.com/in/mile-ristov"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="nav-left-link"
                >
                    Li
                </a>
            </div>
            <div className="nav-left-item">
                <a
                    href="https://github.com/Mileristov"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="nav-left-link"
                >
                    GIT
                </a>
            </div>
            <div className="nav-line"></div>
            <div className="nav-left-item nav-copyright">
                <div className="copyright">©/2022</div>
            </div>
        </div>
    );
};

export default Navbar;
